<template>
  <div class="dp-lang" role="group" :aria-label="t('dp.common.language')">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="dp-lang-option"
      :class="{ 'is-active': locale === option.value }"
      :aria-pressed="locale === option.value"
      :lang="option.value"
      :title="option.label"
      @click="setLocale(option.value)"
    >
      {{ option.short }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { useDataPortalI18n, type DataPortalLocale } from '../i18n';

const { t, locale, setLocale } = useDataPortalI18n();
const options: Array<{
  value: DataPortalLocale;
  short: string;
  label: string;
}> = [
  { value: 'de', short: 'DE', label: 'Deutsch' },
  { value: 'en', short: 'EN', label: 'English' },
];
</script>

<style scoped>
.dp-lang {
  display: inline-flex;
  padding: 0.15rem;
  border: 1px solid var(--dp-color-border);
  border-radius: 999px;
  background: var(--dp-color-surface);
}
.dp-lang-option {
  min-width: 2.2rem;
  padding: 0.25rem 0.55rem;
  border: 0;
  border-radius: 999px;
  color: var(--dp-color-muted);
  background: transparent;
  font: 750 0.72rem var(--dp-font-body);
  letter-spacing: 0.04em;
  cursor: pointer;
}
.dp-lang-option.is-active {
  color: var(--dp-color-surface);
  background: var(--dp-color-navy);
}
.dp-lang-option:focus-visible {
  outline: 2px solid var(--dp-color-orange);
  outline-offset: 1px;
}
</style>
